<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="6000402">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="oaLoan.ajax?cmd=queryOaLoanTable"
          :params="fullSearchData"
          bizName="借支核销数据导出"
          bizCode="exp100034"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'orderId'"
                  @click="toOrderDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-if="scope.column.property !== 'orderId'"
                  :class="{ primary: scope.$index === 0 }"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  borrowWriteOffList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'oaLoanId', label: '借支流水号', fixed: true },
          { prop: 'appDate', label: '借支时间' },
          { prop: 'amountStr', label: '借支金额' },
          { prop: 'payIdStr', label: '支付流水号' },
          { prop: 'lastVerifDate', label: '最近核销时间' },
          { prop: 'lastVerifAmountStr', label: '最近核销金额' },
          { prop: 'payedAmountStr', label: '累计核销金额' },
          { prop: 'salaryDeductionStr', label: '工资抵扣金额' },
          { prop: 'noPayedAmountStr', label: '未核销金额' },
          { prop: 'classifyName', label: '借支入口' },
          { prop: 'loanSubjectName', label: '借支科目' },
          { prop: 'orderId', label: '订单号' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'userName', label: '申请姓名' },
          { prop: 'mobilePhone', label: '申请号码' },
          { prop: 'borrower', label: '借支姓名' },
          { prop: 'borrowerPhone', label: '借支号码' },
          { prop: 'loanStsName', label: '核销状态' },
          { prop: 'auditkman0', label: '一级审核' },
          { prop: 'auditkman1', label: '二级审核' },
          { prop: 'auditkman2', label: '三级审核' },
          { prop: 'auditkman3', label: '四级审核' },
          { prop: 'auditkman4', label: '五级审核' },
          { prop: 'lastVerifName', label: '核销人' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: borrowWriteOffList,
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
